export default theme => ({
  section__background: {
    "@media (max-width: 400px)": {
      padding: 10,
    },
    "@media (max-width: 600px)": {
      padding: 20,
    },
    padding: 30,
  },
  section: {
    maxWidth: 1500,
    margin: "auto",
  },
  spaced: {
    marginTop: 30,
  },
  section__subsection: {
    backgroundColor: theme.palette.shadow.light,
    marginBottom: 30,
    padding: 5,
    "@media (max-width: 600px)": {
      overflow: "auto",
    },
  },
});
